import { useEffect, useState } from 'react';

import { useCustomLogger } from '@vp/pdp-ubik-logging';
import { AlertBox, Link } from '@vp/swan';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { Breadcrumb } from '../infrastructure/clients/server-side/urlMetadataClient';
import { isOutOfStock as getIsOutOfStock } from '../managers/client-side/inventoryManager';

import { useAuthContext } from './AuthProvider';

interface IOutOfStockToastProps {
  tenant: string;
  locale: string;
  productKey: string;
  productVersion: number;
  categoryBreadcrumb: Breadcrumb | undefined;
}

export const OutOfStockToast: React.FC<IOutOfStockToastProps> = ({
  tenant,
  locale,
  productKey,
  productVersion,
  categoryBreadcrumb,
}) => {
  const { authorizationHeader } = useAuthContext();
  const [isOutOfStock, setIsOutOfStock] = useState(false);
  const { t } = useLocalizations();
  const { logger } = useCustomLogger();

  useEffect(() => {
    const getGlobalStock = async () => {
      if (authorizationHeader) {
        const outOfStock = await getIsOutOfStock(
          tenant,
          locale,
          productKey,
          productVersion,
          {
            Authorization: authorizationHeader,
          },
          logger
        );
        setIsOutOfStock(outOfStock);
      }
    };

    getGlobalStock();
  }, [productKey, productVersion, tenant, locale, authorizationHeader]);

  if (!isOutOfStock) return null;

  if (categoryBreadcrumb) {
    return (
      <AlertBox
        skin="warning"
        data-testid="out-of-stock-toast-no-date"
        marginTop={'3'}
        aria-live="polite"
        accessibleTextForIcon={t('warning')}
      >
        {t('item-out-of-stock-no-date')}
        <Link href={categoryBreadcrumb.url} paddingLeft={'2'}>
          {categoryBreadcrumb.name}
        </Link>
      </AlertBox>
    );
  }
  return (
    <AlertBox
      skin="warning"
      data-testid="out-of-stock-toast"
      aria-live="polite"
      accessibleTextForIcon={t('warning')}
    >
      {t('item-out-of-stock')}
    </AlertBox>
  );
};
